import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { Alert, Box, Button, Typography, Grid, Avatar } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import { TextField } from "formik-mui";
import { useLocation, useNavigate, Link } from "react-router-dom";

import { useAuth } from "@poseidon/ui/components/AuthContext";
import { LoginSchema } from "@poseidon/utils/authFieldUtils";
import PasswordField from "@poseidon/ui/components/form/PasswordField";

export const Login = ({ allowRegister = true }) => {
  let navigate = useNavigate();
  let location = useLocation();
  let { signIn } = useAuth();
  let [error, setError] = useState();

  // the screen the user was on before they were redirected to the login
  let from = location.state?.from?.pathname || "/";
  let message = location.state?.message;

  return (
    <>
      <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Login
      </Typography>
      {message && (
        <Alert severity="info" sx={{ my: 4, width: "100%" }}>
          {message}
        </Alert>
      )}
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        validationSchema={LoginSchema}
        onSubmit={async (values) => {
          try {
            // Send them back to the page they tried to visit when they were
            // redirected to the login page. Use { replace: true } so we don't create
            // another entry in the history stack for the login page.  This means that
            // when they get to the protected page and click the back button, they
            // won't end up back on the login page, which is also really nice for the
            // user experience.
            await signIn(values.email, values.password);
            navigate(from, { replace: true });
          } catch (error) {
            setError(error.code);
          }
        }}
      >
        {({ errors, touched }) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              width: "100%",
            }}
          >
            <Field
              autoComplete="email"
              autoFocus
              component={TextField}
              error={errors.email && touched.email ? true : false}
              fullWidth
              id="email"
              label="Email"
              margin="normal"
              name="email"
              required
              type="email"
            />
            <Field
              autoComplete="current-password"
              component={PasswordField}
              error={errors.password && touched.password ? true : false}
              fullWidth
              id="password"
              label="Password"
              margin="normal"
              name="password"
              required
            />
            {error && (
              <Typography color="error" mb={1}>
                {error}
              </Typography>
            )}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              margin="normal"
              fullWidth
              sx={{ mt: 3, mb: 2 }}
            >
              Login
            </Button>
          </Form>
        )}
      </Formik>
      <Grid container>
        <Grid item xs>
          <Link to="/auth/forgot-password">
            <Typography variant="body2" color="text.secondary">
              Forgot password?
            </Typography>
          </Link>
        </Grid>
        {allowRegister && (
          <Grid item>
            <a
              href="https://forms.gle/PDwkyhSiLmRVJ7559"
              target="_blank"
              style={{ margin: "10px 0" }}
              rel="noopener noreferrer"
            >
              <Typography variant="body2" color="text.secondary">
                {"Become an authorised dealer"}
              </Typography>
            </a>
          </Grid>
        )}
      </Grid>
    </>
  );
};
